import React from 'react'
import {campaignStatusClassMap} from '../helpers'
import {useTranslation} from "react-i18next";

const CampaignStatus = ({ status }) => {
    const { t } = useTranslation();

    const statusMap = campaignStatusClassMap()

    return (
        <div className={`chipLike ${statusMap[status]}`}>
            <span className='chipLikeLabel'>{t(`CampaignStatuses.${status}`)}</span>
        </div>
    )
}

export default CampaignStatus
